import React, { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { FaInstagram, FaLinkedinIn, FaFacebookF } from "react-icons/fa";

const ContactSection = () => {
    const [formData, setFormData] = useState({
        name: "",

        configuration: "",
        remark: "",
    });
    const url = process.env.REACT_APP_LINK
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const payload = {
                ...formData,
                user_id: "HBTR0001", // ✅ change if needed
                enquiry_source: "Contact Page",
                source: window.location.href,
            };

            const response = await fetch(`${url}/contact`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.success) {
                alert("Thank you for contacting us!");
                setFormData({ name: "", configuration: "", remark: "" });
            } else {
                alert("Failed to submit. Please try again.");
            }
        } catch (err) {
            console.error("Submission error:", err);
            alert("Something went wrong!");
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (
        <>
            <div className="contact-sections">
                <div className="contact-section-header">
                    <h2>Get in Touch with Us Today</h2>
                    <p>Questions, concerns, or just want to talk about your dream property? Our doors are always open</p>
                </div>
                <div className="contact-section">
                    <div className="contact-left">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <label>Name</label>
                            <input type="text" name="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} />

                            <label>Configuaration</label>
                            <input type="text" name="configuration" placeholder="Eg. 2BHK, 3BHK..." value={formData.configuration} onChange={handleChange} />

                            <label>Message</label>
                            <textarea rows="4" name="remark" placeholder="Write your message..." value={formData.remark} onChange={handleChange}></textarea>

                            <button type="submit" disabled={isSubmitting}>
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </form>
                    </div>

                    <div className="contact-right">
                        <div className="contact-info">
                            <p><Mail size={18} />  info@westerns360.com </p>
                            <p><Phone size={18} /> +91 96190 33222</p>
                            <p><MapPin size={24} /> Shop No 15, Swapnpurti Chs Ltd, Thakur Village, Opposite Viceroy Savana, Kandivali East, Mumbai - 400101</p>
                        </div>

                        <div className="socials">
                            <h4>Stay Connected</h4>
                            <div className="social-icons">
                                <a href="https://www.instagram.com/westerns360/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                                <a href="#"><FaLinkedinIn /></a>
                                <a href="#"><FaFacebookF /></a> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactSection;
